<template>
  <div class="money-coming-in-widget-container">
    <div v-if="loading" class="money-coming-in-widget-loading">Loading...</div>
    <div v-else-if="error" class="money-coming-in-widget-error">{{ error }}</div>
    <div v-else class="money-coming-in-widget-content">
      <div class="money-coming-in-widget-header">
        <div class="money-coming-in-widget-header-label">Total Amount</div>
        <div class="money-coming-in-widget-header-value money-coming-in-widget-positive">{{ formatCurrency(totalInvoiceAmount) }}</div>
      </div>
      <div class="money-coming-in-widget-details">
        <div class="money-coming-in-widget-detail-row">
          <div class="money-coming-in-widget-detail-label">Invoice Sent</div>
          <div class="money-coming-in-widget-detail-value">{{ formatCurrency(totalInvoiceAmount) }}</div>
        </div>
        <div class="money-coming-in-widget-detail-row">
          <div class="money-coming-in-widget-detail-label">Amount Received</div>
          <div class="money-coming-in-widget-detail-value money-coming-in-widget-positive">{{ formatCurrency(amountReceived) }}</div>
        </div>
        <div class="money-coming-in-widget-detail-row">
          <div class="money-coming-in-widget-detail-label">Amount Pending</div>
          <div class="money-coming-in-widget-detail-value money-coming-in-widget-pending">{{ formatCurrency(amountPending) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/MoneyComingInWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'MoneyComingInWidget',
  props: {
    companyId: { type: [String, Number], required: true }
  },
  data() {
    return {
      totalInvoiceAmount: 0,
      amountReceived: 0,
      amountPending: 0,
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        // Fetch all invoices
        const invoices = await ApiService.getAllCustomerInvoices(this.companyId);
        const invoicesArray = Array.isArray(invoices) ? invoices : [];
        
        // Filter out draft and cancelled invoices
        const validInvoices = invoicesArray.filter(inv => 
          inv.status !== 'draft' && inv.status !== 'cancelled'
        );
        
        // Calculate totals
        this.totalInvoiceAmount = validInvoices.reduce((sum, inv) => {
          return sum + parseFloat(inv.totalAmount || 0);
        }, 0);
        
        // Calculate amount received (total - balance)
        this.amountReceived = validInvoices.reduce((sum, inv) => {
          const totalAmount = parseFloat(inv.totalAmount || 0);
          const balanceAmount = parseFloat(inv.balanceAmount || inv.balanceDue || 0);
          return sum + (totalAmount - balanceAmount);
        }, 0);
        
        // Calculate amount pending (balance due)
        this.amountPending = validInvoices.reduce((sum, inv) => {
          return sum + parseFloat(inv.balanceAmount || inv.balanceDue || 0);
        }, 0);
      } catch (error) {
        logger.error('Error fetching money coming in:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

